import {
  Button,
  Flex,
  FlexProps,
  forwardRef,
  Icon,
  IconProps,
  Text,
} from '@chakra-ui/react'
import React, { ReactNode, useMemo } from 'react'

import {
  TextButtonVariants,
  useTextButtonStyle,
} from './componentStyles/TextButton.style'

interface TextButtonProps {
  children: ReactNode
  textButtonProps?: FlexProps
  leftIcon?: SVGComponent
  leftIconProps?: IconProps
  rightIcon?: SVGComponent
  rightIconProps?: IconProps
  iconSize?: string
  variant?: TextButtonVariants
  onLinkClick: () => void
  hoverChanged?: (hovered: boolean) => void
}
export const TextButton = forwardRef<TextButtonProps, 'div'>(
  (
    {
      children,
      textButtonProps,
      onLinkClick,
      hoverChanged,
      leftIcon,
      leftIconProps,
      rightIcon,
      rightIconProps,
      iconSize,
      variant,
    }: TextButtonProps,
    ref,
  ) => {
    const styles = useTextButtonStyle({ iconSize, variant })

    const leftIconContent = useMemo(() => {
      if (!leftIcon) {
        return null
      }

      return (
        <Icon
          as={leftIcon}
          {...leftIconProps}
          sx={{ ...styles.icon, ...leftIconProps?.sx }}
        />
      )
    }, [leftIcon])

    const rightIconContent = useMemo(() => {
      if (!rightIcon) {
        return null
      }

      return (
        <Icon
          as={rightIcon}
          {...rightIconProps}
          sx={{ ...styles.icon, ...rightIconProps?.sx }}
        />
      )
    }, [rightIcon])

    return (
      <Flex
        data-group
        {...textButtonProps}
        sx={{ ...styles.container, ...textButtonProps?.sx }}
        as={Button}
        onClick={onLinkClick}
        ref={ref}
      >
        {leftIconContent}
        <Text
          sx={styles.text}
          onMouseEnter={() => hoverChanged?.(true)}
          onMouseLeave={() => hoverChanged?.(false)}
        >
          {children}
        </Text>
        {rightIconContent}
      </Flex>
    )
  },
)
